const VERSION = String.raw`(\d+\.\d+\.\d+)`;
const PLAIN_VERSION = new RegExp(String.raw`^${VERSION}(?:-preconfigured)?$`);
const MSI_NAME = new RegExp(
  String.raw`(?:^|[\\/])(?:Wylo\.RC\.Agent(?:\.(?:test|prod))?|Wylo\.RC)\.${VERSION}\.msi$`,
  "i",
);

export function publishedAgentLabel(release: { published: boolean; version: string | null } | undefined): string {
  if (!release?.published) return "not published";
  const text = release.version?.trim() ?? "";
  if (text.length === 0) return "not published";
  const named = MSI_NAME.exec(text);
  if (named?.[1]) return named[1];
  const plain = PLAIN_VERSION.exec(text);
  if (plain?.[1]) return plain[1];
  return "version unknown";
}
